export enum NotificationType {
  PROMOTOR_AUSENTE = 'PROMOTOR_AUSENTE',
  PROBLEMAS_NAO_RESOLVIDOS = 'PROBLEMAS_NAO_RESOLVIDOS',
}

type NotificationTypeInterface = keyof typeof NotificationType

export const notificationTypeEnumMap: Record<NotificationTypeInterface, string> = {
  PROMOTOR_AUSENTE: 'Ausência de promotor',
  PROBLEMAS_NAO_RESOLVIDOS: 'Problema com produto',
}
